import {

  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse

} from '@angular/common/http';

import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { AuditService } from '../services/audit.service';
import { tap } from 'rxjs/operators';

@Injectable()
export class AuditInterceptor implements HttpInterceptor {

  private processedRequests = new Set<string>();

  constructor(
    private auditService: AuditService
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {

    /*
    |--------------------------------------------------------------------------
    | AUDITABLE ENDPOINTS
    |--------------------------------------------------------------------------
    */

    const auditableEndpoints = [

      '/users/create',
      '/users/update',
      '/users/delete',
      '/users/delete',
      '/users/delete',

      '/clients/create',
      '/clients/update',
      '/clients/delete',

      '/settings/update',

      '/reports/export',

      '/auth/login'

    ];

    const shouldAudit = auditableEndpoints.some(endpoint =>
      req.url.includes(endpoint)
    );

    /*
    |--------------------------------------------------------------------------
    | IGNORE NON AUDITABLE
    |--------------------------------------------------------------------------
    */

    if (!shouldAudit) {
      return next.handle(req);
    }

    /*
    |--------------------------------------------------------------------------
    | UNIQUE REQUEST
    |--------------------------------------------------------------------------
    */

    const requestKey =
      `${req.method}-${req.url}-${JSON.stringify(req.body)}`;

    if (this.processedRequests.has(requestKey)) {
      return next.handle(req);
    }

    this.processedRequests.add(requestKey);

    setTimeout(() => {
      this.processedRequests.delete(requestKey);
    }, 3000);

    return next.handle(req).pipe(

      tap({

        next: (event:any) => {

          if (!(event instanceof HttpResponse)) {
            return;
          }

          /*
          |--------------------------------------------------------------------------
          | SUCCESS AUDIT
          |--------------------------------------------------------------------------
          */

          this.auditService.registrar({

            roleName:
              localStorage.getItem('role') || 'User',

            responsibleUser:
              localStorage.getItem('user') || 'Unknown',

            actionName:
              this.getAction(req.method),

            moduleName:
              this.getModule(req.url),

            movement:
              `${this.getAction(req.method)} operation executed successfully`,

            urlEndpoint: req.url,

            statusName: 'CORRECTO',

            previousData: null,

            newData: JSON.stringify(req.body),

            createdBy:
              localStorage.getItem('user') || 'System'

          });

        },

        error: (error:any) => {

          /*
          |--------------------------------------------------------------------------
          | ERROR AUDIT
          |--------------------------------------------------------------------------
          */

          this.auditService.registrar({

            roleName:
              localStorage.getItem('role') || 'User',

            responsibleUser:
              localStorage.getItem('user') || 'Unknown',

            actionName:
              this.getAction(req.method),

            moduleName:
              this.getModule(req.url),

            movement:
              `Failed operation: ${error.message}`,

            urlEndpoint: req.url,

            statusName: 'ERROR',

            previousData: null,

            newData: JSON.stringify(req.body),

            createdBy:
              localStorage.getItem('user') || 'System'

          });

        }

      })

    );

  }

  /*
  |--------------------------------------------------------------------------
  | ACTION NAME
  |--------------------------------------------------------------------------
  */

  getAction(method: string): string {

    switch (method) {

      case 'POST':
        return 'CREATE';

      case 'PUT':
        return 'UPDATE';

      case 'DELETE':
        return 'DELETE';

      default:
        return method;

    }

  }

  /*
  |--------------------------------------------------------------------------
  | MODULE NAME
  |--------------------------------------------------------------------------
  */

  getModule(url: string): string {

    if (url.includes('/users')) {
      return 'Users';
    }

    if (url.includes('/clients')) {
      return 'Clients';
    }

    if (url.includes('/settings')) {
      return 'Settings';
    }

    if (url.includes('/reports')) {
      return 'Reports';
    }

    return 'General';

  }

}